import { Navigate } from 'react-router-dom'

import StaffPersonalSpaceJourneyDetailsHome from '../../components/pages/staff-personal-space/my-journeys/home/staff-personal-space-journey-details-home'
import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import MissionToStaffTravelExpensesPage from './mission-to-staff-travel-expenses'
import StaffAvailabilityPage from './staff-availability'
import { StaffContractsPage } from './staff-contracts'
import StaffPersonalSpaceJourneyDetails from './staff-home/staff-personal-space-journey-details'
import StaffPersonalSpaceJourneyDetailsActivitiesAndBudget from './staff-home/staff-personal-space-journey-details-activities-and-budget'
import StaffPersonalSpaceJourneyDetailsDailyReport from './staff-home/staff-personal-space-journey-details-daily-report'
import StaffPersonalSpaceJourneyDetailsEndOfStayReport from './staff-home/staff-personal-space-journey-details-end-of-stay-report'
import StaffPersonalSpaceJourneyDetailsExpensesNote from './staff-home/staff-personal-space-journey-details-expenses-note'
import StaffPersonalSpaceJourneyDetailsGuide from './staff-home/staff-personal-space-journey-details-guide'
import StaffPersonalSpaceQuestionnaire from './staff-home/staff-personal-space-journey-details-questionnaire'
import StaffPersonalSpaceJourneyDetailsStudents from './staff-home/staff-personal-space-journey-details-students'
import StaffPersonalSpaceLayout from './staff-home/staff-personal-space-layout'
import { StaffPersonalSpaceTravel } from './staff-home/staff-personal-space-travel'
import { StaffMissionReportPage } from './staff-mission-report'
import { StaffMissionsPage } from './staff-missions'
import StaffPersonalSpaceMyJourneysPage from './staff-personal-space-my-journeys'
import StaffPersonalSpacePayScaleTable from './staff-personal-space-pay-scale-table'
import StaffProfilePage from './staff-profile'

const staffPersonalSpaceRoutes: Route[] = [
  {
    path: Paths.STAFF_PERSONAL_SPACE_INFORMATION,
    element: <StaffProfilePage />,
    roles: [RoleEnum.STAFF]
  },
  {
    path: Paths.STAFF_PERSONAL_SPACE_CONTRACTS,
    element: <StaffContractsPage />,
    roles: [RoleEnum.STAFF]
  },
  {
    path: Paths.STAFF_PERSONAL_SPACE_MISSIONS,
    element: <StaffMissionsPage />,
    roles: [RoleEnum.STAFF]
  },
  {
    path: Paths.STAFF_PERSONAL_SPACE_MISSION_TRAVEL_EXPENSES,
    element: <MissionToStaffTravelExpensesPage />,
    roles: [RoleEnum.STAFF]
  },
  {
    path: Paths.STAFF_PERSONAL_SPACE_AVAILABILITY,
    element: <StaffAvailabilityPage />,
    roles: [RoleEnum.STAFF]
  },
  {
    path: Paths.STAFF_PERSONAL_SPACE_PAY_SCALE_TABLE,
    element: <StaffPersonalSpacePayScaleTable />,
    roles: [RoleEnum.STAFF]
  },
  {
    path: Paths.STAFF_PERSONAL_SPACE_MY_JOURNEYS,
    element: <StaffPersonalSpaceMyJourneysPage />,
    roles: [RoleEnum.STAFF]
  },
  {
    path: Paths.STAFF_PERSONAL_SPACE_MISSION_REPORT,
    element: <StaffMissionReportPage />,
    roles: [RoleEnum.STAFF]
  },
  {
    path: Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS,
    element: <StaffPersonalSpaceLayout />,
    roles: [RoleEnum.STAFF],
    children: [
      {
        path: '',
        element: <StaffPersonalSpaceJourneyDetails />,
        children: [
          {
            path: Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_HOME,
            element: <StaffPersonalSpaceJourneyDetailsHome />,
            roles: [RoleEnum.STAFF]
          },
          {
            path: Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_GUIDE,
            element: <StaffPersonalSpaceJourneyDetailsGuide />,
            roles: [RoleEnum.STAFF]
          },
          {
            path: Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_TRIP_INFORMATION,
            element: <StaffPersonalSpaceTravel />,
            roles: [RoleEnum.STAFF]
          },
          {
            path: Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_STUDENTS,
            element: <StaffPersonalSpaceJourneyDetailsStudents />,
            roles: [RoleEnum.STAFF]
          },
          {
            path: Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_ACTIVITIES_AND_BUDGET,
            element: <StaffPersonalSpaceJourneyDetailsActivitiesAndBudget />,
            roles: [RoleEnum.STAFF]
          },
          {
            path: Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_QUESTIONNAIRE,
            element: <StaffPersonalSpaceQuestionnaire />,
            roles: [RoleEnum.STAFF]
          },
          {
            path: Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_EXPENSES_NOTE,
            element: <StaffPersonalSpaceJourneyDetailsExpensesNote />,
            roles: [RoleEnum.STAFF]
          },
          {
            path: Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_DAILY_REPORT,
            element: <StaffPersonalSpaceJourneyDetailsDailyReport />,
            roles: [RoleEnum.STAFF]
          },
          {
            path: Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_END_OF_STAY_REPORT,
            element: <StaffPersonalSpaceJourneyDetailsEndOfStayReport />,
            roles: [RoleEnum.STAFF]
          },
          {
            index: true,
            element: <Navigate to={Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_HOME} />,
            roles: [RoleEnum.STAFF]
          }
        ]
      }
    ]
  }
]

export default staffPersonalSpaceRoutes
